var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineGateHighOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "202px",
    viewBox: "0 0 15 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9AD8\u538B\u5F15\u7EBF\u95F8\u5200\u56DE\u8DEF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    transform: "translate(-286.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9AD8\\u538B\\u5F15\\u7EBF\\u95F8\\u5200\\u56DE\\u8DEF",
    transform: "translate(287.000000, 761.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 1.26374605e-14,
    x2: 6.5,
    y2: 71,
    id: "\\u76F4\\u7EBF",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 129,
    x2: 6.5,
    y2: 200,
    id: "\\u76F4\\u7EBF-7",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD-19",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 16.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 41.5,
    x2: 6.5,
    y2: 57.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-2",
    points: "13 14 6.5 8 4.14945855e-15 14"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#59D744",
    x: 2,
    y: 17,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(0.000000, 44.000000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-3",
    transform: "translate(6.500000, 3.000000) scale(1, -1) translate(-6.500000, -3.000000) ",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-4",
    transform: "translate(6.500000, 11.000000) scale(1, -1) translate(-6.500000, -11.000000) ",
    points: "13 14 6.5 8 4.14945855e-15 14"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGateHighOpen);
export default __webpack_public_path__ + "static/media/lineGate_high_open.32a97f8ebdd390506e5e08b866255e2c.svg";
export { ForwardRef as ReactComponent };